export default "__VITE_ASSET__s08YI$Ce__"